import React, { useEffect, useState } from 'react';

const ShimmerLoader = () => (
    <div className="p-24">
        {[60, 90, 85].map((width, i) => (
            <div key={i}
                style={{
                    backgroundColor: '#e0e0e0',
                    height: '14px',
                    width: `${width}%`,
                    marginBottom: '12px',
                    borderRadius: '6px'
                }}
                className="animate-pulse"
            />
        ))}
    </div>
);

const ConversationSummaryTab = ({ conversationData, currentId, isLoading }) => {
    const [localLoading, setLocalLoading] = useState(true);

    useEffect(() => {
        setLocalLoading(true);
        const timeout = setTimeout(() => setLocalLoading(false), 500);
        return () => clearTimeout(timeout);
    }, [conversationData, currentId]);

    const loading = isLoading || localLoading;

    if (!conversationData || loading) {
        return (
            <div className="col-xxl-3 col-lg-4">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-24 px-24 bg-base border-bottom">
                        <h6 className="text-lg mb-0">Analytics</h6>
                    </div>
                    <ShimmerLoader />
                </div>
            </div>
        );
    }

    const detail_Summary = conversationData?.calls?.[0]?.analysis?.summary || 'No summary available.';
    const success_Evaluation = conversationData?.calls?.[0]?.analysis?.successEvaluation || false;
    const structuredData = conversationData?.calls?.[0]?.analysis?.structuredData || null;
    const variableData = conversationData?.calls?.[0]?.assistantOverrides?.variableValues || null;

    const startedAt = conversationData?.calls?.[0]?.startedAt &&
        new Date(conversationData.calls[0].startedAt).toLocaleString();
    const endedAt = conversationData?.calls?.[0]?.endedAt &&
        new Date(conversationData.calls[0].endedAt).toLocaleString();

    return (
        <div className="col-xxl-3 col-lg-4">
            <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                <div className="card-header py-24 px-24 bg-base border-bottom">
                    <h6 className="text-lg mb-0">Analytics</h6>
                </div>
                <div className="card-body p-24 pt-10">
                    <ul className="nav bordered-tab nav-pills mb-16" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link active px-16 py-10"
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                type="button"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                            >
                                Summary
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10"
                                id="pills-details-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-details"
                                type="button"
                                role="tab"
                                aria-controls="pills-details"
                                aria-selected="false"
                            >
                                Evaluation
                            </button>
                        </li>
                        {((structuredData && Object.keys(structuredData).length > 0) || (variableData && Object.keys(variableData).length > 0)) && (
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link px-16 py-10"
                                    id="pills-structured-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-structured"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-structured"
                                    aria-selected="false"
                                >
                                    Lead Info
                                </button>
                            </li>
                        )}
                    </ul>

                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className="tab-pane fade show active"
                            id="pills-home"
                            role="tabpanel"
                            aria-labelledby="pills-home-tab"
                            tabIndex={0}
                        >
                            <h6 className="text-lg mb-8">Detail Summary</h6>
                            <p className="text-secondary-light mb-0">{detail_Summary}</p>
                        </div>

                        <div
                            className="tab-pane fade"
                            id="pills-details"
                            role="tabpanel"
                            aria-labelledby="pills-details-tab"
                            tabIndex={0}
                        >
                            <h6 className="text-lg mb-8">Success Evaluation</h6>
                            <p className="text-secondary-light mb-0">
                                {success_Evaluation ? (
                                    <span className="badge text-sm fw-semibold rounded-pill bg-success-600 px-20 py-9 radius-4 text-white">Success</span>
                                ) : (
                                    <span className="badge text-sm fw-semibold rounded-pill bg-danger-600 px-20 py-9 radius-4 text-white">Failure</span>
                                )}
                            </p>
                        </div>

                        {((structuredData && Object.keys(structuredData).length > 0) || (variableData && Object.keys(variableData).length > 0)) && (
                            <div
                                className="tab-pane fade"
                                id="pills-structured"
                                role="tabpanel"
                                aria-labelledby="pills-structured-tab"
                                tabIndex={0}
                            >
                                {variableData && Object.keys(variableData).length > 0 && (
                                    <>

                                        <ul className="list-group list-group-flush mb-3">
                                            {Object.entries(variableData).map(([key, value]) => (
                                                <li key={`lead-${key}`} className="list-group-item px-2 py-2 border-bottom d-flex align-items-start">
                                                    <span className="me-2 text-muted">{key.charAt(0).toUpperCase() + key.slice(1)}:</span>
                                                    <span>{String(value)}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                                {structuredData && Object.keys(structuredData).length > 0 && (
                                    <>
                                        <h6 className="text-lg mb-2">Structured Data</h6>
                                        <ul className="list-group list-group-flush">
                                            {Object.entries(structuredData).map(([key, value]) => {
                                                const label = key
                                                    .replace(/_/g, ' ')
                                                    .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
                                                return (
                                                    <li key={key} className="list-group-item px-2 py-2 border-bottom d-flex align-items-start">
                                                        <span className="me-2 text-muted">{label}:</span>
                                                        <span>{String(value)}</span>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </>
                                )}
                            </div>
                        )}


                    </div>
                </div>

                <div className="card-footer bg-white px-3 py-3 border-top">
                    <div className="flex justify-between text-xs text-gray-500">
                        <span style={{ fontSize: '11px' }}>
                            Call ID: {conversationData?.calls?.[0]?.id || 'Unknown'}
                        </span>
                    </div>
                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                        <span>Started: {startedAt || 'N/A'}</span>
                        <span>Ended: {endedAt || 'N/A'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConversationSummaryTab;